import { zhCN } from 'date-fns/locale';
const dateZhCN = {
  name: 'zh-CN',
  locale: zhCN
};
export default dateZhCN;